// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { Alert } from '@/components/ui/feedback';
import { IconArrowLeft, IconMailCheck, IconMail, IconRefresh } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function EmailVerificationPage() {
  const [isVerified, setIsVerified] = useState(false);

  const handleResend = () => {
    console.log('Resending verification email');
  };

  if (isVerified) {
    return (
      <AuthLayoutWrapper variant="gradient" gradientFrom="#22c55e" gradientTo="#10b981" glassEffect>
        <Stack gap="lg" align="center">
          <Center
            style={{
              width: 80,
              height: 80,
              borderRadius: 20,
              backgroundColor: 'var(--mantine-color-green-light)',
            }}
          >
            <IconMailCheck size={40} color="var(--mantine-color-green-6)" />
          </Center>

          <Stack align="center" gap="xs">
            <Title order={2} ta="center">Email verified!</Title>
            <Text c="dimmed" ta="center" maw={300}>
              Your email has been successfully verified. You can now access all features.
            </Text>
          </Stack>

          <Button
            component={Link}
            to="/app/demo/auth-pages/login/gradient"
            fullWidth
            variant="gradient"
            gradient={{ from: 'green', to: 'teal' }}
          >
            Continue to Login
          </Button>
        </Stack>
      </AuthLayoutWrapper>
    );
  }

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/other"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to Other Pages
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                backgroundColor: 'var(--mantine-color-blue-light)',
              }}
            >
              <IconMail size={36} color="var(--mantine-color-blue-6)" />
            </Center>
            <Title order={2} ta="center">Verify your email</Title>
            <Text c="dimmed" size="sm" ta="center" maw={320}>
              We've sent a verification link to <strong>john@example.com</strong>.
              Click the link to verify your account.
            </Text>
          </Stack>
        </Center>

        {/* Alert */}
        <Alert color="blue" variant="light">
          <Text size="sm">
            Check your inbox and spam folder. The link expires in 24 hours.
          </Text>
        </Alert>

        {/* Actions */}
        <Stack gap="sm">
          <Button
            fullWidth
            variant="light"
            leftSection={<IconRefresh size={16} />}
            onClick={handleResend}
          >
            Resend verification email
          </Button>

          <Button
            fullWidth
            variant="subtle"
            onClick={() => setIsVerified(true)}
          >
            I've verified my email
          </Button>
        </Stack>

        {/* Help text */}
        <Text ta="center" size="sm" c="dimmed">
          Wrong email?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/register/simple">
            Change email address
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
